import React from 'react';
import { Card, CardContent } from '../UI/card';
import { CreditCard, Smartphone, Banknote, CheckCircle } from 'lucide-react';

/**
 * COMPOSANT: SÉLECTION DU MODE DE PAIEMENT
 * 
 * Permet de choisir parmi les modes de paiement disponibles
 */

const PaymentMethodSelector = ({ onSelect, allowedMethods, selectedMethod }) => {
  const paymentMethods = [
    {
      value: 'CARTE_BANCAIRE',
      label: 'Carte Bancaire',
      icon: CreditCard,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50 hover:bg-blue-100',
      description: 'Visa, Mastercard, Verve'
    },
    {
      value: 'MOBILE_MONEY',
      label: 'Mobile Money',
      icon: Smartphone,
      color: 'text-orange-600',
      bgColor: 'bg-orange-50 hover:bg-orange-100',
      description: 'Orange, MTN, Moov, Wave'
    },
    {
      value: 'VIREMENT_BANCAIRE',
      label: 'Virement Bancaire',
      icon: CreditCard,
      color: 'text-indigo-600',
      bgColor: 'bg-indigo-50 hover:bg-indigo-100',
      description: 'Transfert bancaire'
    },
    // Méthodes supplémentaires pour agent/admin
    {
      value: 'ORANGE_MONEY',
      label: 'Orange Money',
      icon: Smartphone,
      color: 'text-orange-600',
      bgColor: 'bg-orange-50 hover:bg-orange-100',
      description: 'Paiement mobile Orange'
    },
    {
      value: 'MTN_MONEY',
      label: 'MTN Mobile Money',
      icon: Smartphone,
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50 hover:bg-yellow-100',
      description: 'Paiement mobile MTN'
    },
    {
      value: 'MOOV_MONEY',
      label: 'Moov Money',
      icon: Smartphone,
      color: 'text-blue-500',
      bgColor: 'bg-blue-50 hover:bg-blue-100',
      description: 'Paiement mobile Moov'
    },
    {
      value: 'WAVE',
      label: 'Wave',
      icon: Smartphone,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50 hover:bg-purple-100',
      description: 'Paiement mobile Wave'
    },
    {
      value: 'ESPECES',
      label: 'Espèces',
      icon: Banknote,
      color: 'text-green-600',
      bgColor: 'bg-green-50 hover:bg-green-100',
      description: 'Paiement en liquide'
    },
    {
      value: 'CHEQUE',
      label: 'Chèque',
      icon: CreditCard,
      color: 'text-gray-600',
      bgColor: 'bg-gray-50 hover:bg-gray-100',
      description: 'Paiement par chèque'
    }
  ];

  // Filtrer les méthodes autorisées
  const filteredMethods = paymentMethods.filter(method =>
    allowedMethods.includes(method.value)
  );

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Choisissez votre mode de paiement</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {filteredMethods.map((method) => {
          const Icon = method.icon;
          const isSelected = selectedMethod === method.value;

          return (
            <Card
              key={method.value}
              className={`cursor-pointer transition-all ${
                isSelected
                  ? 'ring-2 ring-primary border-primary'
                  : 'hover:shadow-md'
              }`}
              onClick={() => onSelect(method.value)}
            >
              <CardContent className="p-4">
                <div className="flex items-start justify-between">
                  <div className="flex items-start space-x-3">
                    <div className={`p-2 rounded-lg ${method.bgColor}`}>
                      <Icon className={`w-6 h-6 ${method.color}`} />
                    </div>
                    <div>
                      <h4 className="font-semibold">{method.label}</h4>
                      <p className="text-sm text-muted-foreground">
                        {method.description}
                      </p>
                    </div>
                  </div>
                  {isSelected && (
                    <CheckCircle className="w-5 h-5 text-primary" />
                  )}
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default PaymentMethodSelector;
